import Axios from "../baseApi";
export default {
  async create(data) {
    try{
      const response = await Axios.put('/api-master-data/v1/salutation', data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async update(id, data) {
    try{
      const response = await Axios.post('/api-master-data/v1/salutation/' + id, data);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async delete(id) {
    try{
      const response = await Axios.delete('/api-master-data/v1/salutation/' + id);
      return response.data;
    } catch (error) {
      return await Promise.reject(error);
    }
  },
  async list() {
    return  await Axios.get('/api-master-data/v1/salutation/list');
  }
}
